export class SessionStorageManager {

    constructor(key) {
        this.key = key;
    }

    getItem() {
        try {
            return JSON.parse(sessionStorage.getItem(this.key));
        } catch (e) {
            return null;
        }
    }

    setItem(data) {
        try {
            sessionStorage.setItem(this.key, JSON.stringify(data));
        } catch (e) {
            return null;
        }

        return true;
    }

    deleteItem() {
        try {
            sessionStorage.removeItem(this.key);
        } catch (e) {
            return null;
        }

        return true;
    }
}

export class LocalStorageManager {

    constructor(key) {
        this.key = key;
    }

    getItem() {
        try {
            return JSON.parse(localStorage.getItem(this.key));
        } catch (e) {
            return null;
        }
    }

    setItem(data) {
        try {
            localStorage.setItem(this.key, JSON.stringify(data));
        } catch (e) {
            return null;
        }

        return true;
    }

    deleteItem() {
        try {
            localStorage.removeItem(this.key);
        } catch (e) {
            return null;
        }

        return true;
    }
}
